import { render, staticRenderFns } from "./OutagesFooter.vue?vue&type=template&id=0eadc59a"
import script from "./OutagesFooter.vue?vue&type=script&lang=js"
export * from "./OutagesFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports